import { useMutation } from 'react-query';
import { dataSubjectRight } from '../DataSubjectRight';

export function useDataSubjectRightVerifyOtp() {
  return useMutation(async (requestData: { otp: string; requestId: string }) => {
    const { data: authData } = await dataSubjectRight.getAccessToken();
    const { data } = await dataSubjectRight.verifyOtp(requestData, authData.access_token);
    return data;
  });
}
